import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
import { SectionLabel } from '../ui/SectionLabel';
const tags = ['Devolución sin complicaciones', 'Pago seguro', 'Soporte por email'];
export function Guarantee() {
  return <section aria-labelledby="garantia-title" className="w-full bg-ink-850" data-id="element-95" data-mp="24mevv68jt7ae">
      <div className="mx-auto max-w-4xl px-5 py-16 md:py-20" data-id="element-96" data-mp="29e6nlk3fxj24">
        <SectionLabel data-id="element-97" data-mp="29frlnjoyrk4q">Cero riesgo · Compra protegida</SectionLabel>
        <h2 id="garantia-title" className="mt-5 font-display text-3xl font-black leading-tight text-white md:text-4xl" data-id="element-98" data-mp="2echwnslwvpja">
          Garantía de 7 días
        </h2>
        <div className="mt-8 flex flex-col items-start gap-6 rounded-2xl border border-brand-green/30 bg-brand-greenDeep/40 p-7 shadow-panel sm:flex-row md:p-9" data-id="element-99" data-mp="2ociknruq6ttt">
          <span className="flex h-16 w-16 shrink-0 items-center justify-center rounded-2xl bg-brand-green/15" data-id="element-100" data-mp="txod40gnp78y">
            <ShieldCheckIcon className="h-8 w-8 text-brand-green" aria-hidden="true" data-id="element-101" data-mp="xxzwzb1733jd" />
          </span>
          <div data-id="element-102" data-mp="3slolj5itmc8j">
            <h3 className="font-display text-xl font-bold text-white md:text-2xl" data-id="element-103" data-mp="3sm85ers17ap7">
              Probalo sin riesgo
            </h3>
            <p className="mt-3 text-[15px] leading-relaxed text-body" data-id="element-104" data-mp="3nsn8l326cmrl">
              Descargá El Método del Padre del Futbolista, abrí el material y revisalo completo. Si
              sentís que no te ayuda a entender mejor el fútbol juvenil argentino y a tomar mejores
              decisiones para acompañar a tu hijo, podés solicitar la devolución dentro del plazo de
              garantía.
            </p>
            <ul className="mt-5 flex flex-wrap gap-2" data-id="element-105" data-mp="5gqoddxcf4lh">
              {tags.map(tag => <li key={tag} className="rounded-full bg-brand-greenDeep px-3 py-1 text-xs font-semibold text-brand-greenSoft" data-id="element-106" data-mp="5ijwyyrinyw4">
                  {tag}
                </li>)}
            </ul>
          </div>
        </div>
      </div>
    </section>;
}